var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"ml-2",attrs:{"open-on-hover":true,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"outlined":""},on:{"click":_vm.copy,"blur":function($event){_vm.show = false}}},on),[_c('MyIcon',{attrs:{"name":"mdi:link-variant"}})],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.info))])])}
var staticRenderFns = []

export { render, staticRenderFns }